export interface PromoCode {
  id: string;
  code: string;
  description?: string;
  plan: 'basic' | 'pro';
  durationMonths: number;
  maxUses?: number | null;
  usedCount: number;
  expiresAt?: string | null;
  isActive: boolean;
  createdBy?: string;
  createdAt: string;
}

export interface PromoCodeRedemption {
  id: string;
  redeemedAt: string;
  user: {
    id: string;
    phoneNumber: string;
    name?: string;
    createdAt: string;
  };
}

export interface PromoCodeDetail {
  code: PromoCode;
  redemptions: PromoCodeRedemption[];
}

export interface CreatePromoCodeInput {
  code: string;
  description?: string;
  plan?: 'basic' | 'pro';
  durationMonths?: number;
  maxUses?: number | null;
  expiresAt?: string | null;
}

export interface CreatePromoCodeResponse {
  success: boolean;
  promoCode: PromoCode;
  inviteLink: string;
}

export type PromoCodeStatus = 'active' | 'inactive' | 'exhausted' | 'expired';

export function getPromoCodeStatus(code: PromoCode): PromoCodeStatus {
  if (!code.isActive) return 'inactive';
  if (code.expiresAt && new Date(code.expiresAt) < new Date()) return 'expired';
  if (code.maxUses && code.usedCount >= code.maxUses) return 'exhausted';
  return 'active';
}
